module.exports = __webpack_public_path__ + "img/status_success.77293667.png";